import { useState } from 'react'
import { message } from 'antd'
import { submitFileToCensusV1 } from '../../../api/hris-api-client'
import {
  acquireSubmitLock,
  isSubmitLocked,
  releaseSubmitLock,
} from '../utils/submitLock'

export function useSubmitFileToCensusV1() {
  const [loadingFileId, setLoadingFileId] = useState<string | null>(null)

  const submit = async (fileId: string, onSuccess?: () => void) => {
    // Hard guard, independent of any React state: catches the case where
    // another tab (or this same tab, before a reload) already has this file
    // mid-submit, even if the button hasn't visually updated to reflect it.
    if (isSubmitLocked(fileId)) {
      message.warning(
        'This file is already being submitted — please wait a moment and refresh before trying again.'
      )
      return
    }

    acquireSubmitLock(fileId)
    setLoadingFileId(fileId)
    try {
      const resp = await submitFileToCensusV1(fileId)
      message.success('File submitted successfully')
      onSuccess?.()
      return resp
    } catch (error: any) {
      message.error(`Failed to submit file: ${error.message}`)
      console.error(error)
    } finally {
      releaseSubmitLock(fileId)
      setLoadingFileId(null)
    }
  }

  return { submit, loadingFileId }
}
